module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-12.2d879545.png";